import { render, staticRenderFns } from "./ExpertCardItaly.vue?vue&type=template&id=0c934710&scoped=true"
import script from "./ExpertCardItaly.vue?vue&type=script&lang=js"
export * from "./ExpertCardItaly.vue?vue&type=script&lang=js"
import style0 from "./ExpertCardItaly.vue?vue&type=style&index=0&id=0c934710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c934710",
  null
  
)

export default component.exports